import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const echo = new Echo({
  broadcaster: 'pusher',
  disableStats: true,
  key: window.config.pusher.key,
  cluster: window.config.pusher.cluster,
  forceTLS: true,
  httpHost: window.config.pusher.host,
  httpPort: window.config.pusher.port,
  wsHost: window.config.pusher.host,
  wsPort: window.config.pusher.port,
});

window.Echo = echo;

export default echo;
